var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoingout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.207031,
    y: 0.194824,
    width: 100,
    height: 100,
    rx: 50,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.207,
    cy: 50.1948,
    r: 44.5,
    stroke: "#F6E003"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17363_86660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5856 63.4014L67.1219 64.5558L64.3293 53.7374C67.7816 51.7804 69.6506 47.6905 68.6061 43.6555L64.8131 28.989L50.0476 32.8041L35.4691 29.11L31.731 43.7874C30.7085 47.8224 32.5775 51.9013 36.0408 53.8473L33.2812 64.6768L28.8175 63.5444L27.707 67.8871L41.1751 71.3174L42.2856 66.9746L37.8219 65.8422L40.5815 55.0127C44.5504 54.9577 48.1566 52.2751 49.1791 48.2402L50.1795 44.3152L51.18 48.1852C52.2245 52.2091 55.8307 54.8918 59.8106 54.9248L62.6032 65.7432L58.1395 66.8976L59.2609 71.2294L72.707 67.7552L71.5856 63.4234V63.4014Z",
    fill: "#F6E003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17363_86660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 42.3064,
    fill: "white",
    transform: "translate(27.707 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoingout);
export default __webpack_public_path__ + "static/media/goingout.303fc66dcf6336841e64669c3979e6e9.svg";
export { ForwardRef as ReactComponent };